import { SessionUserSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { TabIdWithMFAAuthenticationProvider } from '~src/settings/siteAuthSettings/services/SiteAuthenticationSettingsService';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';

import { AppState } from '../../../bootstrap/redux/state/AppState';
import { Messages } from '../../../codegen/Localize';
import { siteUserResetMFA } from '../actions/SiteUserMenuActions';
import { ISiteUserInfo } from '../models/ISiteUserInfo';

export const SiteUserResetMFAAction: IEntityAction<ISiteUserInfo, {}> = {
  name: EntityActionNames.SiteUserResetMFA,
  translateName: Messages.resetMfa_action,
  isVisible: (_targetItems: ISiteUserInfo[], state: AppState) => {
    return SessionUserSelectors.canManageUsers(state) &&
      _targetItems.length === 1 &&
      _targetItems.every(siteUser => siteUser.authenticationProviderId === TabIdWithMFAAuthenticationProvider.id);
  },
  isClickable: (_availableActions: {}, targetItems: ISiteUserInfo[], _state: AppState) => {
    return true;
  },
  createReduxAction: (targetItems: ISiteUserInfo[]) => siteUserResetMFA(targetItems)
};
